import { Title } from '@angular/platform-browser';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { IExamen } from '@app/database/models/IExamen.model';
import { Examen } from '../exams-config/Examen.config';
import { ExamsConfigService } from '../exams-config/exams-config.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { AsideService } from '@shared/components/aside/aside.service';
import { DatabaseService } from '@app/database/database.service';
import moment from 'moment';
import { MessageAlertService } from '@shared/views/_messagesService/_messageAlertServices';
import { BackgroundSyncService } from '@app/helpers/backgroundSync.service';
import { GroupCTemplateService } from '@shared/forms/templates/group-c-template/group-c-template.service';
import { environment } from '@env/environment';
import { ConnectionService, ConnectionState } from 'ng-connection-service';
import { IEspecialidades } from '@app/database/models/IEspecialidades.model';


@Component({
  selector: 'app-group-c-template',
  templateUrl: './group-c-template.component.html',
  styleUrls: ['./group-c-template.component.scss'],
})
export class GroupCTemplateComponent implements OnInit, OnDestroy {
  public currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
  @Input() examen: any;
  submitted = false;
  public examForm: FormGroup;
  seniority = 0;
  unidadTiempo = '';
  maxDate = new Date();
  maxDateIngreso = new Date();
  minDate: any;
  tiposDictamen: any[] = [];
  especialidades: IEspecialidades[];
  asideObservable: Subscription;
  displayAgentes = false;
  listaCampos: string[] = [];
  attachedFiles: any = {
    data: [],
    invalid: false,
    isEmpty: true,
    attachedFilesValidQuantity: 0
  };
  configForm: Examen;
  header: any;
  invalidField = true;
  checked: boolean = true;
  enviandose = false;
  isOnline = true;
  isAntecedentesAccidentesTrabajoPageBreak = false;
  isEstudioClinicoPageBreak = false;
  isVisionDoblePageBreak = false;
  isMareosPageBreak = true;
  isConjuntivitisPageBreak = false;
  isVisionBorrosaPageBreak = false;
  displayModalFirma = false;
	medicoFirmaB64;
  medicoFirmaSigString;

  constructor(
    private titleService: Title,
    private formBuilder: FormBuilder,
    private router: Router,
    private groupCTemplateService: GroupCTemplateService,
    private confirmationService: ConfirmationService,
    private asideService: AsideService,
    private messageAlertServices: MessageAlertService,
    private backgroundSyncService: BackgroundSyncService,
    private examConfigService: ExamsConfigService,
    private databaseService: DatabaseService,
    private connectionService: ConnectionService
  ) { }

  get f(): any {
    return this.examForm.controls;
  }

  ngOnDestroy(): void {
    if (this.asideObservable) {
      this.asideObservable.unsubscribe();
    }
    this.asideService.setInsideExamen(false);
    this.titleService.setTitle('Provincia ART ML Offline');
  }

  ngOnInit(): void {
    this.titleService.setTitle('Provincia ART ML Offline');

    this.connectionService.monitor().subscribe((connected: ConnectionState) => {
      this.isOnline = connected.hasNetworkConnection;
    })
    this.isOnline = JSON.parse(localStorage.getItem('isStillOnline'));

    this.cargarFormulario();
    this.getTiposDictamen();
    this.getEspecialidades();
    this.minDate = new Date(moment(this.examen.fechaAsignacion).format());
    this.asideObservable = this.asideService.openModalSubject$.subscribe(
      (data) => {
        this.goBack(data);
      }
    );
    this.asideService.setInsideExamen(true);
  }

  cargarFormulario() {
    let codigoTipoExamen = (this.examen.tipoEstudio.codigo !== undefined)
      ? this.examen.tipoEstudio.tipoEstudioCod
      : this.examen.tipoEstudio;
    this.configForm = this.examConfigService.getConfig(codigoTipoExamen);
    this.configForm.name = this.examen.provinciaNombreEstudio;
    this.examForm = this.configForm.examForm;
    this.examen.trabajador.apellidoNombre ? this.examForm.controls.apellidoNombre.setValue(this.examen.trabajador.apellidoNombre) : null;
    this.examen.trabajador.fechaNacimiento ? this.examForm.controls.fechaNacimiento.setValue(new Date(moment(this.examen.trabajador.fechaNacimiento).format())) : null;
    this.calculateAge();
    this.examen.puestoTrabajador ?
      this.examForm.controls.puestoTrabajador.setValue(this.examen.puestoTrabajador) : null;
    this.examen.antiguedadPuestoTrabajador ?
      this.examForm.controls.antiguedadPuestoTrabajador.setValue(this._standarizeDate(this.examen.antiguedadPuestoTrabajador)) : null;
    this.examen.fechaIngresoEmpresa ?
      this.examForm.controls.fechaIngresoEmpresa.setValue(new Date(moment(this.examen.fechaIngresoEmpresa).format())) : null;
    this.restrictDateIngresoEmpresa();
    this.medicoFirmaB64 = this.examen.medicoFirmaB64;
    this.medicoFirmaSigString = this.examen.medicoFirmaSigString;
    if (this.examen?.modoVista === "edit" || this.examen.modoVista === 'ver' || this.examen?.cargadoOffline) {
      this.setValuesOnFormOnVerOrEditMode();
    } else {
      this.examen.antecedentesEnfermedad = this.examForm.controls.antecedentesEnfermedad.value;
      this.examen.antecedentesTrastornosCongenitos = this.examForm.controls.antecedentesTrastornosCongenitos.value;
      this.examen.antecedentesEnfermedadesProfesionales = this.examForm.controls.antecedentesEnfermedadesProfesionales.value;
      this.examen.antecedentesTrabajosAnteriores = this.examForm.controls.antecedentesTrabajosAnteriores.value;
      this.examen.cefaleas = this.examForm.controls.cefaleas.value;
      this.examen.visionDoble = this.examForm.controls.visionDoble.value;
      this.examen.mareos = this.examForm.controls.mareos.value;
      this.examen.conjuntivitis = this.examForm.controls.conjuntivitis.value;
      this.examen.visionBorrosa = this.examForm.controls.visionBorrosa.value;
      this.examen.ojosCentrados = this.examForm.controls.ojosCentrados.value;
      this.examen.conjuntivasNormal = this.examForm.controls.conjuntivasNormal.value;
      this.examen.conjuntivasAnormal = this.examForm.controls.conjuntivasAnormal.value;
      this.examen.motilidadNormal = this.examForm.controls.motilidadNormal.value;
      this.examen.motilidadAnormal = this.examForm.controls.motilidadAnormal.value;
      this.examen.fotosensibilidad = this.examForm.controls.fotosensibilidad.value;
      this.examen.pupilasNormal = this.examForm.controls.pupilasNormal.value;
      this.examen.pupilasAnormal = this.examForm.controls.pupilasAnormal.value;
      this.examen.corneasNormal = this.examForm.controls.corneasNormal.value;
      this.examen.corneasAnormal = this.examForm.controls.corneasAnormal.value;
      this.examen.nistagmusNormal = this.examForm.controls.nistagmusNormal.value;
      this.examen.nistagmusAnormal = this.examForm.controls.nistagmusAnormal.value;
      this.validateCheckboxItems();
    }
  }

  /**
   * Metodo que se encarga de obtener los tipos de dictamen
   */
  async getTiposDictamen(): Promise<void> {
    const dataFromOffline = await this.databaseService.getAllTiposDictamenFromOfflineDB();
    this.tiposDictamen = dataFromOffline.filter(
      (x) => x.codigo === 'A' || x.codigo === 'I' || x.codigo === 'N'
    );
  }

  _standarizeDate(date: any) {
    let splitedDate = date.replace(/\//g, '-');
    const dateParts = splitedDate.split('-');
    if (date.includes('/')) {
      return new Date(parseInt(dateParts[2]), parseInt(dateParts[1]) - 1, parseInt(dateParts[0]));
    } else {
      return new Date(parseInt(dateParts[0]), parseInt(dateParts[1]) - 1, parseInt(dateParts[2]));
    }
  }

  // ESPECIALIDADES
  async getEspecialidades(): Promise<void> {
    const especialidadesListFromOffline = await this.databaseService.getAllEspecialidadesFromOfflineDB();
    this.especialidades = especialidadesListFromOffline;
  }

  /**
   * Metodo que se encarga de calcular la antiguedad del trabajador (en meses o años)
   */
  calcularAntiguedad() {
    if (this.examen.fechaAltaEmpleado) {
      this.seniority = moment().diff(
        moment(this.examen.fechaAltaEmpleado),
        'years'
      );
      if (this.seniority > 1) {
        this.unidadTiempo = 'años';
      } else if (this.seniority < 1) {
        this.seniority = moment().diff(
          moment(this.examen.fechaAltaEmpleado),
          'months'
        );
        if (this.seniority > 1) {
          this.unidadTiempo = 'meses';
        } else {
          this.unidadTiempo = 'mes';
        }
      } else {
        this.unidadTiempo = 'año';
      }
    }
  }

  async onSubmit(): Promise<any> {
    this.submitted = true;
    this.validateSeccionOjos();
    if (this.examForm.invalid || this.invalidField || this.attachedFiles.invalid || this.medicoFirmaB64 == null) {      this.navigateInvalidField('ng-invalid');
      return;
    }
    this.enviandose = true;
    if (this.isOnline) {
      this.saveToOnline();
    } else {
      this.saveToOffline();
    }
  }

  /**
   * Metodo que se encarga
   * @param ruta
   */
  goBack(ruta?) {
    if (this.examForm.dirty) {
      this.confirm(ruta);
    } else {
      this.returnToExams(ruta);
    }
  }

  /**
   * Metodo que se encarga de abrir el modal y redirigir a la pagina de la ruta que recibe
   * @param ruta ruta para redirigir
   */
  confirm(ruta?) {
    this.confirmationService.confirm({
      header: `¿Está seguro de que desea cancelar la carga del estudio?`,
      message: `Si cancela el examen ahora perderá toda la información cargada hasta el momento`,
      key: 'goBackFormEC',
      accept: () => {
        this.returnToExams(ruta);
      },
    });
  }

  returnToExams(ruta?) {
    this.router.navigate([ruta ? ruta : 'examenes']);
  }

  buildRequest() {
    let examFormData = { ...this.examForm.getRawValue() };
    examFormData.userId = this.currentUser.userId;
    examFormData.username = this.currentUser.username;
    examFormData.modelId = this.currentUser.modelId;
    examFormData.tipoEstudio = this.configForm.code;
    examFormData.examenNumero = this.examen.id;
    examFormData.medicoMatricula = examFormData.matricula;
    examFormData.fechaRealizacion = moment(examFormData.fechaRealizacion).format(
      'yyyy-MM-DD'
    );
    examFormData.fechaIngresoEmpresa = moment(examFormData.fechaIngresoEmpresa).format(
      'yyyy-MM-DD'
    );
    examFormData.antiguedadPuestoTrabajador = moment(examFormData.antiguedadPuestoTrabajador).format('yyyy-MM-DD');

    switch (this.configForm.code) {
      case 'ILUMI':
        examFormData = this.buildIluminacionInsuficiente(examFormData);
        break;
      default:
        break;
    }
    this.examen?.modoVista === "edit" ? examFormData.esEdicion = !!(this.examen?.modoVista === "edit" && this.isOnline) : null;
    examFormData.adjuntos = this.attachedFiles.data;
    examFormData.medicoFirmaB64 = this.medicoFirmaB64;
    examFormData.medicoFirmaSigString = this.medicoFirmaSigString;
  
		examFormData = this.evaluateChangeTrabajador(examFormData);

		return examFormData;
	}

	private evaluateChangeTrabajador(object) {
		if (this.examen.seModificoTrabajador 
			|| this.examen.trabajador.fechaNacimiento != moment(this.examForm.controls.fechaNacimiento.value).format('yyyy-MM-DD')
			|| this.examen.trabajador.apellidoNombre != this.examForm.controls.apellidoNombre.value) {

			object.trabajador = {
				apellidoNombre: this.examForm.controls.apellidoNombre.value,
				fechaNacimiento: moment(this.examForm.controls.fechaNacimiento.value).format('yyyy-MM-DD')
			};
			this.examen.seModificoTrabajador = true;
		}
		return object;
	}
    
  buildIluminacionInsuficiente(examFormData) {

    examFormData.antecedentesEnfermedad = examFormData.antecedentesEnfermedadSi ? true : false;
    examFormData.antecedentesTrastornosCongenitos = examFormData.antecedentesTrastornosCongenitosSi ? true : false;
    examFormData.antecedentesEnfermedadesProfesionales = examFormData.antecedentesEnfermedadesProfesionalesSi ? true : false;
    examFormData.antecedentesTrabajosAnteriores = examFormData.antecedentesTrabajosAnterioresSi ? true : false;
    examFormData.cefaleas = examFormData.cefaleasSi ? true : false;
    examFormData.visionDoble = examFormData.visionDobleSi ? true : false;
    examFormData.mareos = examFormData.mareosSi ? true : false;
    examFormData.conjuntivitis = examFormData.conjuntivitisSi ? true : false;
    examFormData.visionBorrosa = examFormData.visionBorrosaSi ? true : false;
    examFormData.ojosCentrados = examFormData.ojosCentradosSi ? true : false;
    examFormData.fotosensibilidad = examFormData.fotosensibilidadSi ? true : false;

    return examFormData;
  }

  clickCheckBox(valor, event) {
    switch (valor) {
      case 'antecedentesEnfermedadSi':
        this.examForm.controls.antecedentesEnfermedadNo.setValue(false);
        this.clickCheckboxHabilitar(event.checked, true, 'observacionesAntEnfermedad');
        this.pageBreakTextAreas();
        break;
      case 'antecedentesEnfermedadNo':
        this.examForm.controls.antecedentesEnfermedadSi.setValue(false);
        this.clickCheckboxHabilitar(event.checked, false, 'observacionesAntEnfermedad');
        this.pageBreakTextAreas();
        break;
      case 'antecedentesTrastornosCongenitosSi':
        this.examForm.controls.antecedentesTrastornosCongenitosNo.setValue(false);
        this.clickCheckboxHabilitar(event.checked, true, 'observacionesAntTrastornosCongenitos');
        this.pageBreakTextAreas();
        break;
      case 'antecedentesTrastornosCongenitosNo':
        this.examForm.controls.antecedentesTrastornosCongenitosSi.setValue(false);
        this.clickCheckboxHabilitar(event.checked, false, 'observacionesAntTrastornosCongenitos');
        this.pageBreakTextAreas();
        break;
      case 'antecedentesEnfermedadesProfesionalesSi':
        this.examForm.controls.antecedentesEnfermedadesProfesionalesNo.setValue(false);
        this.clickCheckboxHabilitar(event.checked, true, 'observacionesAntEnfermedadesProfesionales');
        this.pageBreakTextAreas();
        break;
      case 'antecedentesEnfermedadesProfesionalesNo':
        this.examForm.controls.antecedentesEnfermedadesProfesionalesSi.setValue(false);
        this.clickCheckboxHabilitar(event.checked, false, 'observacionesAntEnfermedadesProfesionales');
        this.pageBreakTextAreas();
        break;
      case 'antecedentesTrabajosAnterioresSi':
        this.examForm.controls.antecedentesTrabajosAnterioresNo.setValue(false);
        this.clickCheckboxHabilitar(event.checked, true, 'observacionesAntTrabajosAnteriores');
        this.pageBreakTextAreas();
        break;
      case 'antecedentesTrabajosAnterioresNo':
        this.examForm.controls.antecedentesTrabajosAnterioresSi.setValue(false);
        this.clickCheckboxHabilitar(event.checked, false, 'observacionesAntTrabajosAnteriores');
        this.pageBreakTextAreas();
        break;
      case 'cefaleasSi':
        this.examForm.controls.cefaleasNo.setValue(false);
        this.clickCheckboxHabilitar(event.checked, true, 'descripcionCefaleas');
        this.pageBreakTextAreas();
        break;
      case 'cefaleasNo':
        this.examForm.controls.cefaleasSi.setValue(false);
        this.clickCheckboxHabilitar(event.checked, false, 'descripcionCefaleas');
        this.pageBreakTextAreas();
        break;
      case 'visionDobleSi':
        this.examForm.controls.visionDobleNo.setValue(false);
        this.clickCheckboxHabilitar(event.checked, true, 'descripcionVisionDoble');
        this.pageBreakTextAreas();
        break;
      case 'visionDobleNo':
        this.examForm.controls.visionDobleSi.setValue(false);
        this.clickCheckboxHabilitar(event.checked, false, 'descripcionVisionDoble');
        this.pageBreakTextAreas();
        break;
      case 'mareosSi':
        this.examForm.controls.mareosNo.setValue(false);
        this.clickCheckboxHabilitar(event.checked, true, 'descripcionMareos');
        this.pageBreakTextAreas();
        break;
      case 'mareosNo':
        this.examForm.controls.mareosSi.setValue(false);
        this.clickCheckboxHabilitar(event.checked, false, 'descripcionMareos');
        this.pageBreakTextAreas();
        break;
      case 'conjuntivitisSi':
        this.examForm.controls.conjuntivitisNo.setValue(false);
        this.clickCheckboxHabilitar(event.checked, true, 'descripcionConjuntivitis');
        this.pageBreakTextAreas();
        break;
      case 'conjuntivitisNo':
        this.examForm.controls.conjuntivitisSi.setValue(false);
        this.clickCheckboxHabilitar(event.checked, false, 'descripcionConjuntivitis');
        this.pageBreakTextAreas();
        break;
      case 'visionBorrosaSi':
        this.examForm.controls.visionBorrosaNo.setValue(false);
        this.clickCheckboxHabilitar(event.checked, true, 'descripcionVisionBorrosa');
        this.pageBreakTextAreas();
        break;
      case 'visionBorrosaNo':
        this.examForm.controls.visionBorrosaSi.setValue(false);
        this.clickCheckboxHabilitar(event.checked, false, 'descripcionVisionBorrosa');
        this.pageBreakTextAreas();
        break;
      case 'ojosCentradosSi':
        this.examForm.controls.ojosCentradosNo.setValue(false);
        this.validateCheckboxItems();
        break;
      case 'ojosCentradosNo':
        this.examForm.controls.ojosCentradosSi.setValue(false);
        this.validateCheckboxItems();
        break;
      case 'conjuntivasNormal':
        this.examForm.controls.conjuntivasAnormal.setValue(false);
        this.validateCheckboxItems();
        break;
      case 'conjuntivasAnormal':
        this.examForm.controls.conjuntivasNormal.setValue(false);
        this.validateCheckboxItems();
        break;
      case 'fotosensibilidadSi':
        this.examForm.controls.fotosensibilidadNo.setValue(false);
        this.validateCheckboxItems();
        break;
      case 'fotosensibilidadNo':
        this.examForm.controls.fotosensibilidadSi.setValue(false);
        this.validateCheckboxItems();
        break;
      case 'pupilasNormal':
        this.examForm.controls.pupilasAnormal.setValue(false);
        this.validateCheckboxItems();
        break;
      case 'pupilasAnormal':
        this.examForm.controls.pupilasNormal.setValue(false);
        this.validateCheckboxItems();
        break;
      case 'corneasNormal':
        this.examForm.controls.corneasAnormal.setValue(false);
        this.validateCheckboxItems();
        break;
      case 'corneasAnormal':
        this.examForm.controls.corneasNormal.setValue(false);
        this.validateCheckboxItems();
        break;
      case 'motilidadNormal':
        this.examForm.controls.motilidadAnormal.setValue(false);
        this.validateCheckboxItems();
        break;
      case 'motilidadAnormal':
        this.examForm.controls.motilidadNormal.setValue(false);
        this.validateCheckboxItems();
        break;
      case 'nistagmusNormal':
        this.examForm.controls.nistagmusAnormal.setValue(false);
        this.validateCheckboxItems();
        break;
      case 'nistagmusAnormal':
        this.examForm.controls.nistagmusNormal.setValue(false);
        this.validateCheckboxItems();
        break;
    }
  }

  clickCheckboxHabilitar(checked, value, field): void {
    this.validateCheckboxItems();
    if (!value || !checked) {
      this.examForm.controls[field].disable();
      this.examForm.controls[field].setValue('');
      this.examForm.controls[field].setValidators(null);
    } else {
      this.examForm.controls[field].enable();
      this.examForm.controls[field].setValidators([
        Validators.required,
        Validators.maxLength(1000),
      ]);
    }
    this.examForm.controls[field].updateValueAndValidity();
  }


  validateCheckboxItems(): void {
    if ((!this.examForm.controls.antecedentesEnfermedadNo.value && !this.examForm.controls.antecedentesEnfermedadSi.value) ||
      (!this.examForm.controls.antecedentesTrastornosCongenitosNo.value && !this.examForm.controls.antecedentesTrastornosCongenitosSi.value) ||
      (!this.examForm.controls.antecedentesEnfermedadesProfesionalesNo.value && !this.examForm.controls.antecedentesEnfermedadesProfesionalesSi.value) ||
      (!this.examForm.controls.antecedentesTrabajosAnterioresNo.value && !this.examForm.controls.antecedentesTrabajosAnterioresSi.value) ||
      (!this.examForm.controls.cefaleasNo.value && !this.examForm.controls.cefaleasSi.value) ||
      (!this.examForm.controls.visionDobleNo.value && !this.examForm.controls.visionDobleSi.value) ||
      (!this.examForm.controls.mareosNo.value && !this.examForm.controls.mareosSi.value) ||
      (!this.examForm.controls.conjuntivitisNo.value && !this.examForm.controls.conjuntivitisSi.value) ||
      (!this.examForm.controls.visionBorrosaNo.value && !this.examForm.controls.visionBorrosaSi.value) ||
      (!this.examForm.controls.ojosCentradosNo.value && !this.examForm.controls.ojosCentradosSi.value) ||
      (!this.examForm.controls.conjuntivasAnormal.value && !this.examForm.controls.conjuntivasNormal.value) ||
      (!this.examForm.controls.fotosensibilidadNo.value && !this.examForm.controls.fotosensibilidadSi.value) ||
      (!this.examForm.controls.pupilasAnormal.value && !this.examForm.controls.pupilasNormal.value) ||
      (!this.examForm.controls.corneasAnormal.value && !this.examForm.controls.corneasNormal.value) ||
      (!this.examForm.controls.motilidadAnormal.value && !this.examForm.controls.motilidadNormal.value) ||
      (!this.examForm.controls.nistagmusAnormal.value && !this.examForm.controls.nistagmusNormal.value)) {
      this.invalidField = true;
    } else {
      this.invalidField = false;
    }
  }

  pageBreakTextAreas(): void {
    !this.examForm.controls.observacionesAntEnfermedad.disabled  ||
      !this.examForm.controls.observacionesAntTrastornosCongenitos.disabled ||
      !this.examForm.controls.observacionesAntEnfermedadesProfesionales.disabled ?
      this.isAntecedentesAccidentesTrabajoPageBreak = true : this.isAntecedentesAccidentesTrabajoPageBreak = false;

    this.isAntecedentesAccidentesTrabajoPageBreak && (!this.examForm.controls.observacionesAntEnfermedadesProfesionales.disabled ||
      !this.examForm.controls.observacionesAntTrabajosAnteriores.disabled) ?
      this.isEstudioClinicoPageBreak = true : this.isEstudioClinicoPageBreak = false;

    this.isAntecedentesAccidentesTrabajoPageBreak && !this.isEstudioClinicoPageBreak && !this.examForm.controls.descripcionCefaleas.disabled ?
      this.isEstudioClinicoPageBreak = true : this.isEstudioClinicoPageBreak = this.isEstudioClinicoPageBreak;

    !this.isAntecedentesAccidentesTrabajoPageBreak && (!this.examForm.controls.observacionesAntTrabajosAnteriores.disabled ||
      !this.examForm.controls.descripcionCefaleas.disabled) ? this.isVisionDoblePageBreak = true : this.isVisionDoblePageBreak = false;

    !this.isEstudioClinicoPageBreak && !this.isVisionDoblePageBreak && !this.examForm.controls.descripcionVisionDoble.disabled ?
      this.isVisionDoblePageBreak = true : this.isVisionDoblePageBreak = this.isVisionDoblePageBreak;

    (this.isEstudioClinicoPageBreak && (!this.examForm.controls.descripcionCefaleas.disabled ||
      !this.examForm.controls.descripcionVisionDoble.disabled)) || (!this.isAntecedentesAccidentesTrabajoPageBreak &&
      !this.isEstudioClinicoPageBreak && !this.isVisionDoblePageBreak) ? this.isMareosPageBreak = true : this.isMareosPageBreak = false;

    this.isEstudioClinicoPageBreak && !this.isMareosPageBreak && !this.examForm.controls.descripcionMareos.disabled ?
      this.isMareosPageBreak = true : this.isMareosPageBreak = this.isMareosPageBreak;

    this.isVisionDoblePageBreak && (!this.examForm.controls.descripcionVisionDoble.disabled ||
      !this.examForm.controls.descripcionMareos.disabled) ? this.isConjuntivitisPageBreak = true :
      this.isConjuntivitisPageBreak = false;

    this.isVisionDoblePageBreak && !this.isConjuntivitisPageBreak && !this.examForm.controls.descripcionConjuntivitis.disabled ?
      this.isConjuntivitisPageBreak = true : this.isConjuntivitisPageBreak = this.isConjuntivitisPageBreak;

    (this.isMareosPageBreak && (!this.examForm.controls.descripcionMareos.disabled ||
      !this.examForm.controls.descripcionConjuntivitis.disabled)) || (!this.isEstudioClinicoPageBreak && !this.isVisionDoblePageBreak &&
      !this.isMareosPageBreak && !this.isConjuntivitisPageBreak) ? this.isVisionBorrosaPageBreak = true : this.isVisionBorrosaPageBreak = false;

    this.isMareosPageBreak && !this.isVisionBorrosaPageBreak && !this.examForm.controls.descripcionVisionBorrosa.disabled ?
      this.isVisionBorrosaPageBreak = true : this.isVisionBorrosaPageBreak = this.isVisionBorrosaPageBreak;

  }

  buildUrlApi(method: string): string {
    return `${environment.apiUrl}` + method;
  }

  capitalize(word: string) {
    if (!word) {
      return word;
    }
    return word[0].toUpperCase() + word.substr(1).toLowerCase();
  }

  private saveToOnline(): void {
    this.groupCTemplateService
      .loadExam(this.buildRequest(), this.configForm.baseUrl)
      .subscribe(
        (response) => {
          this.databaseService.deleteItemFromTable(this.examen.id,
            `examenes${(this.examen.categoriaExamen === 'periodicos'
              ? 'Periodicos'
              : 'Reevaluacion')}`);
          this.databaseService.deleteItemFromTable(this.examen.id,
            `examenes${(this.examen.categoriaExamen === 'periodicos'
              ? 'PeriodicosFiltrados'
              : 'ReevaluacionFiltrados')}`);
          this.openSuccessAlert(response.message, 'examen');
        },
        (error) => {
          this.formatResponseAndOpenError(error);
        }
      );
  }

  private saveToOffline(): void {
    const dataToSend = this.buildRequest();
    dataToSend.fechaCarga = moment().format('yyyy-MM-DD');
    dataToSend.cargadoOffline = true;
    const details = (this.examen?.modoVista === "edit") ? 'Los cambios en el examen fueron guardados correctamente' : 'El examen se guardó correctamente en Por enviar';

    this.databaseService
      .setExameneOnExamenesPorEnviarTable(
        this.examen,
        dataToSend,
        false,
        this.examen.categoriaExamen === 'periodicos'
          ? 'Periodicos'
          : 'Reevaluacion',
        this.buildUrlApi(this.configForm.baseUrl)
      )
      .then((response) => {
        this.databaseService.deleteItemFromTable(this.examen.id,
          `examenes${(this.examen.categoriaExamen === 'periodicos'
            ? 'Periodicos'
            : 'Reevaluacion')}`);
        this.databaseService.deleteItemFromTable(this.examen.id,
          `examenes${(this.examen.categoriaExamen === 'periodicos'
            ? 'PeriodicosFiltrados'
            : 'ReevaluacionFiltrados')}`);
        this.backgroundSyncService.registerEvent('save-examen');
        this.openSuccessAlert(
          details,
          'examen'
        );
      })
      .catch((e) => {
        this.messageAlertServices.setMessage(0, {
          severity: 'error',
          summary: '',
          detail:
            'Ha ocurrido un error. Por favor reintente más tarde y disculpe las molestias ocasionadas',
          key: 'examen',
        });
      });
  }

  private calculateAge(): void {
    let edad = null;
    if (this.examForm.controls.fechaNacimiento.value) {
      edad = moment().diff(
        moment(this.examForm.controls.fechaNacimiento.value),
        'years'
      );
    }
    this.examen.trabajador.edad = edad;
  }

  restrictDateIngresoEmpresa(): void {
    if(this.examForm.controls.antiguedadPuestoTrabajador.value != null && this.examForm.controls.antiguedadPuestoTrabajador.value != "") {
      this.maxDateIngreso = this.examForm.controls.antiguedadPuestoTrabajador.value;
    } else {
      this.maxDateIngreso = this.maxDate;
    }
  }

  private navigateInvalidField(classFocus: string): void {
    const invalidFields = [].slice.call(
      document.getElementsByClassName(classFocus)
    );
    const field = invalidFields[1];
    field.scrollIntoViewIfNeeded();
    field.focus();
  }

  private openSuccessAlert(message: string, key: string): void {
    this.enviandose = false;
    this.messageAlertServices.setMessage(0, {
      severity: 'success',
      summary: '',
      detail: message,
      key: key,
    });
    setTimeout(() => {
      this.returnToExams();
    }, 500);
  }

  formatResponseAndOpenError(error) {
		let message = error.error.message + ' ';
		message = message + error.error.errors.map((x) => {
			return x;
		}).join(' ');
		this.openErrorAlert(message, 'examen');
	}

	private openErrorAlert(message: string, key: string): void {
		this.messageAlertServices.setMessage(0, {
			severity: 'error',
			summary: '',
			detail: message,
			key: key,
		});
		setTimeout(() => {
			const header = document.querySelector('#templateContainer') as any;
			window.scroll(0, header.offsetTop - 150);
		}, 100);
		this.enviandose = false;
	}

  /**
   * función que recibe el trigger desde el componente attach-upload-file
   * con el objeto actualizado de la lista de archivos y errores
   * @param  {object} event
   * @example:
   *  {
   *    errors: {
   *      isSizeValid: false
   *      isTypeValid: false,
   *    },
   *    data: [
   *       {
   *        archivoBase64: todounstringpegado,
   *        nombreOriginal: "example.png",
   *        tipo: "png",
   *        size: 121354,
   *        esAlta:false,
   *        esBaja:false
   *    ],
   *    invalid: false,
   *    isEmpty: true,
   *    attachedFilesValidQuantity: 0
   *  }
   */
  getAttachedFiles(event: any): any {
    const { errors } = event;

    this.attachedFiles = event;
    if (errors.isSizeValid && errors.isTypeValid) {
      // asigno la data al objeto para enviar
      return false;
    }
  }

  /**
   * @description:
   * * Asignacion de valores a los campos en modo edicion
   */
  private setValuesOnFormOnVerOrEditMode(): void {
    /*********************
     * * Campos del Header
     *********************/

    // *FECHA DE REALIZACION
    this.examForm.controls.fechaRealizacion.setValue(this.examen.fechaRealizacion);

    /**********************
     *  * Campos del FOOTER
     ***********************/
    this.examen.codigoDictamen = this.examen.tipoDictamen ? this.examen.tipoDictamen : this.examen.codigoDictamen;
    this.examForm.controls.codigoDictamen.setValue(this.examen.codigoDictamen);
    this.examForm.controls.medicoEspecialidad.setValue(this.examen.medicoEspecialidad);
    this.examForm.controls.matricula.setValue(this.examen.medicoMatricula);
    this.examForm.controls.medicoNombre.setValue(this.examen.medicoNombre.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, ''));

    /*********************
     * * Datos del Examen
     *********************/

    this.examForm.controls.observacionesAntEnfermedad?.setValue(this.examen.observacionesAntEnfermedad ?
      this.examen.observacionesAntEnfermedad : "");
    this.examForm.controls.observacionesAntTrastornosCongenitos?.setValue(this.examen.observacionesAntTrastornosCongenitos ?
      this.examen.observacionesAntTrastornosCongenitos : "");
    this.examForm.controls.observacionesAntEnfermedadesProfesionales?.setValue(this.examen.observacionesAntEnfermedadesProfesionales ?
      this.examen.observacionesAntEnfermedadesProfesionales : "");
    this.examForm.controls.observacionesAntTrabajosAnteriores?.setValue(this.examen.observacionesAntTrabajosAnteriores ?
      this.examen.observacionesAntTrabajosAnteriores : "");
    this.examForm.controls.descripcionCefaleas?.setValue(this.examen.descripcionCefaleas ?
      this.examen.descripcionCefaleas : "");
    this.examForm.controls.descripcionVisionDoble?.setValue(this.examen.descripcionVisionDoble ?
      this.examen.descripcionVisionDoble : "");
    this.examForm.controls.descripcionMareos?.setValue(this.examen.descripcionMareos ?
      this.examen.descripcionMareos : "");
    this.examForm.controls.descripcionConjuntivitis?.setValue(this.examen.descripcionConjuntivitis ?
      this.examen.descripcionConjuntivitis : "");
    this.examForm.controls.descripcionVisionBorrosa?.setValue(this.examen.descripcionVisionBorrosa ?
      this.examen.descripcionVisionBorrosa : "");

    this.examForm.controls.ojoIzquierdoSinCorreccion?.setValue(this.examen.ojoIzquierdoSinCorreccion || this.examen.ojoIzquierdoSinCorreccion === 0 ? this.examen.ojoIzquierdoSinCorreccion : null);
    this.examForm.controls.ojoIzquierdoConCorreccion?.setValue(this.examen.ojoIzquierdoConCorreccion || this.examen.ojoIzquierdoConCorreccion === 0 ? this.examen.ojoIzquierdoConCorreccion : null);
    this.examForm.controls.ojoDerechoSinCorreccion?.setValue(this.examen.ojoDerechoSinCorreccion || this.examen.ojoDerechoSinCorreccion === 0 ? this.examen.ojoDerechoSinCorreccion : null);
    this.examForm.controls.ojoDerechoConCorreccion?.setValue(this.examen.ojoDerechoConCorreccion || this.examen.ojoDerechoConCorreccion === 0 ? this.examen.ojoDerechoConCorreccion : null);

    /*********************
     * * Habilitación de campos
     *********************/
    this.examen.antecedentesEnfermedad ? this.clickCheckboxHabilitar(true, true, 'observacionesAntEnfermedad') : null;
    this.examen.antecedentesTrastornosCongenitos ? this.clickCheckboxHabilitar(true, true, 'observacionesAntTrastornosCongenitos') : null;
    this.examen.antecedentesEnfermedadesProfesionales ? this.clickCheckboxHabilitar(true, true, 'observacionesAntEnfermedadesProfesionales') : null;
    this.examen.antecedentesTrabajosAnteriores ? this.clickCheckboxHabilitar(true, true, 'observacionesAntTrabajosAnteriores') : null;
    this.examen.cefaleas ? this.clickCheckboxHabilitar(true, true, 'descripcionCefaleas') : null;
    this.examen.visionDoble ? this.clickCheckboxHabilitar(true, true, 'descripcionVisionDoble') : null;
    this.examen.mareos ? this.clickCheckboxHabilitar(true, true, 'descripcionMareos') : null;
    this.examen.conjuntivitis ? this.clickCheckboxHabilitar(true, true, 'descripcionConjuntivitis') : null;
    this.examen.visionBorrosa ? this.clickCheckboxHabilitar(true, true, 'descripcionVisionBorrosa') : null;

    this.invalidField = false;
    this.pageBreakTextAreas();
  }

  showModalFirma(){
		this.displayModalFirma = true;
	}

	closeModalFirma(){
		this.displayModalFirma = false;
	}

	recibirDatosFirma(datos: { firmaB64: string, firmaSigString: string }) {
		this.medicoFirmaB64 = datos.firmaB64;
		this.medicoFirmaSigString = datos.firmaSigString;
	}

  deshabilitarApellidoNombreTrabajador() {
    return this.examen.trabajador.apellidoNombre.replace(/[^a-zA-Z]/g, '').toLowerCase() !== 'alta' && this.examen.trabajador.apellidoNombre.trim().length !== 0;
  }

  validateSeccionOjos():void{
    if(this.examForm.controls.ojoDerechoConCorreccion.value === null && this.examForm.controls.ojoDerechoSinCorreccion.value === null){
      this.examForm.controls.ojoDerechoSinCorreccion.setValidators([Validators.required,Validators.min( 0 ), Validators.max( 10 )]);
      this.examForm.controls.ojoDerechoConCorreccion.setValidators([Validators.required,Validators.min( 0 ), Validators.max( 10 )]);
    }

    if(this.examForm.controls.ojoIzquierdoConCorreccion.value === null && this.examForm.controls.ojoIzquierdoSinCorreccion.value === null){
      this.examForm.controls.ojoIzquierdoSinCorreccion.setValidators([Validators.required,Validators.min( 0 ), Validators.max( 10 )]);
      this.examForm.controls.ojoIzquierdoConCorreccion.setValidators([Validators.required,Validators.min( 0 ), Validators.max( 10 )]);
    }

    if(this.examForm.controls.ojoDerechoConCorreccion.value || this.examForm.controls.ojoDerechoConCorreccion.value === 0){
      this.examForm.controls.ojoDerechoSinCorreccion.clearValidators();
      this.examForm.controls.ojoDerechoSinCorreccion.setValidators([Validators.min( 0 ), Validators.max( 10 )]);
    }

    if(this.examForm.controls.ojoDerechoSinCorreccion.value || this.examForm.controls.ojoDerechoSinCorreccion.value === 0){
      this.examForm.controls.ojoDerechoConCorreccion.clearValidators();
      this.examForm.controls.ojoDerechoConCorreccion.setValidators([Validators.min( 0 ), Validators.max( 10 )]);
    }

    if(this.examForm.controls.ojoIzquierdoConCorreccion.value || this.examForm.controls.ojoIzquierdoConCorreccion.value === 0){
      this.examForm.controls.ojoIzquierdoSinCorreccion.clearValidators();
      this.examForm.controls.ojoIzquierdoSinCorreccion.setValidators([Validators.min( 0 ), Validators.max( 10 )]);
    }

    if(this.examForm.controls.ojoIzquierdoSinCorreccion.value || this.examForm.controls.ojoIzquierdoSinCorreccion.value === 0){
      this.examForm.controls.ojoIzquierdoConCorreccion.clearValidators();
      this.examForm.controls.ojoIzquierdoConCorreccion.setValidators([Validators.min( 0 ), Validators.max( 10 )]);
    }

    this.examForm.controls.ojoDerechoSinCorreccion.updateValueAndValidity();
    this.examForm.controls.ojoDerechoConCorreccion.updateValueAndValidity();
    this.examForm.controls.ojoIzquierdoSinCorreccion.updateValueAndValidity();
    this.examForm.controls.ojoIzquierdoConCorreccion.updateValueAndValidity();
  }
}
